import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import Table from '../../../../../components/Table/Table';
import BasicCellText from './BasicCellText';
import { getEntityPrefix } from '../../../../../utils/utilFunctions';
import usePaginatedCall from '../../../../../hooks/usePaginatedCall';
import { useGetTemplatesAppliedToQuery } from '../../../../../services/endpoints/templatesEndpoints';
import TableTitle from '../../../../../components/TableTitle/TableTitle';

const AppliedToTable = (columnWidths) => {
	const [searchParams] = useSearchParams();

	const id =
		searchParams?.get('formId') || searchParams?.get('stageId') || searchParams?.get('processId');
	const type = searchParams?.get('formId')
		? 'form'
		: searchParams?.get('stageId')
		? 'stage'
		: 'application-process';

	const finalPagination = usePaginatedCall(useGetTemplatesAppliedToQuery, {
		type: type,
		templateID: id,
		filterBaseName: 'APPLIED_TO_TABLE'
	});
	const [columnWidth, setColumnWidth] = useState({});

	const [openTooltip, setOpenTooltip] = useState(0);
	const columns = [
		{
			field: 'created_on',
			headerName: 'Timestamp',
			description: 'Timestamp',
			renderCell: (cellValues) => {
				const isDisabled = cellValues?.row?.is_archived;

				return (
					<BasicCellText
						cellValues={cellValues}
						openTooltip={openTooltip}
						setOpenTooltip={setOpenTooltip}
						isDisabled={isDisabled}
						isDate
					/>
				);
			},
			flex: columnWidths.created_on || 1
		},
		{
			field: 'created_by',
			headerName: 'User',
			description: 'User',
			renderCell: (cellValues) => {
				const isDisabled = cellValues?.row?.is_archived;
				const user = cellValues?.row?.created_by_user;
				cellValues.formattedValue = `${user?.firstName} ${user?.lastName}`;

				return (
					<BasicCellText
						cellValues={cellValues}
						openTooltip={openTooltip}
						setOpenTooltip={setOpenTooltip}
						isDisabled={isDisabled}
					/>
				);
			},
			flex: columnWidths.created_by || 1
		},
		{
			field: 'id',
			headerName: 'Entity',
			description: 'Entity',
			renderCell: (cellValues) => {
				const type = cellValues.row?.stage_type?.toLowerCase() || 'process';
				const title =
					cellValues.row?.process_name || cellValues.row?.stage_name || cellValues.row?.label;
				const formType = cellValues.row?.form_type;
				const entityType =
					formType === 'application'
						? 'Application Form'
						: formType === 'review'
						? 'Review Form'
						: type == 'application'
						? 'Submission Stage'
						: type == 'evaluation'
						? 'Evaluation Stage'
						: 'Application Process';
				const StagePrefix = getEntityPrefix({ type: entityType, isMaters: true });
				const displayId = StagePrefix + cellValues.row?.unique_identifier;
				const titleData = {
					title,
					entityType,
					displayId,
					isTemplate: true
				};

				return <TableTitle titleData={titleData} />;
			},
			flex: columnWidths.appId || 1,
			minWidth: 250
		}
	];

	return (
		<Table
			hideFilters
			key={'Applied-Table'}
			disableSelectionOnClick
			getRowId={(cell) => cell?.stage_id || cell?.form_id || cell?.process_id}
			columns={columns}
			rowHeight={true}
			enableAutoPageSize
			onColumnResize={(e) => {
				const newColumnSizes = e?.colDef?.field;
				const width = e?.width;
				setColumnWidth({ ...columnWidth, [newColumnSizes]: width });
			}}
			rows={finalPagination?.rows?.results || []}
			rowCount={finalPagination?.rowCount}
			pagination={finalPagination?.pagination}
			pageSize={finalPagination?.pageSize}
			paginationMode={finalPagination?.paginationMode}
			onPageChange={(e) => finalPagination?.onPageChange(e)}
			onPageSizeChange={(e) => finalPagination?.onPageSizeChange(e)}
			page={finalPagination?.page}
			loading={finalPagination?.loading}
			sortingMode={finalPagination?.sortingMode}
			onSortModelChange={(e) => finalPagination?.onSortModelChange(e)}
			filterModel={finalPagination?.filterModel}
			sortModel={finalPagination?.sortModel}
		/>
	);
};

export default AppliedToTable;
